import { render } from "./webNavDrawer.vue?vue&type=template&id=1afe087c&scoped=true&ts=true"
import script from "./webNavDrawer.vue?vue&type=script&lang=ts"
export * from "./webNavDrawer.vue?vue&type=script&lang=ts"

import "./webNavDrawer.vue?vue&type=style&index=0&id=1afe087c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afe087c"]])

export default __exports__